// extracted by mini-css-extract-plugin
module.exports = {"mask":"Mask_mask__1tskw"};